<template >
  <!-- 素材区组件 material  -->
  <div class="material" id="MATERIAL-SWF">

    <div class="mask" v-show="mask_visible"></div>

    <div v-loading="loading && 0 == public_list_data.length" v-show="loading" element-loading-text=""  element-loading-background="#3a3a3a" class="loading">
      <span v-show="loading" style="color:white;width:100%;height:30px;left:0;right:0;top:55%;margin:auto;text-align:center;position:absolute;line-height:30px;">数据加载中</span>
    </div>

    <!-- 切换标签组件 tabs -->
    <div class="tabs">
      <div
        v-for="item, index in tab_tab"
        :class="{'active':item.active}"
        @click="handleTabChange(index)">
        {{item.name.length>6?item.name.substring(0,6)+'...':item.name}}
      </div>
    </div>

    <!-- 搜索组件 search @focus="searchInputFocus" @blur="searchInputBlur"-->
    <div class="search" v-show="!theme_show">
      <div class="search-inner">
        <input type="text" class="text" placeholder="请输入素材名称、版权方、标签" @keyup.13="handdleStartSearch" v-model="search_key" >
        <span class="icon-search button" @click="handdleStartSearch"></span>
        <span class="el-icon-close button" @click="handleCloseSearch" v-show="search_key.length > 0"></span>
      </div>
    </div>
    <!-- 切换标签组件  category-->
    <div class="category-nav">
      <span class="bottom" v-for="item, index in tab_category" :class="{'active':item.active}">
        <div :class="{'active':item.active}" @click="handleCategoryChange(index)">{{item.name}}</div>
      </span>
      <!-- <div v-for="item, index in tab_category" :class="{'active':item.active}" @click="handleCategoryChange(index)">{{item.name}}</div>   -->
    </div>

    <!-- 播放组件 -->
    <div class="player" v-show="music_play_status && tab_category_init == 'bgm'">
      <div class="box-music">
        <div class="title">已选: &nbsp {{bgm_title}}<i @click="handleBgmCancle" class="el-icon-close"></i></div>
        <div class="control">
          <div class="play_pause">
            <i @click="handleBgmPlay" class="icon-play" v-show="!play_status"></i>
            <i @click="handleBgmPause" class="icon-pause" v-show="play_status"></i>
            <i class="icon-mute" style="font-size:24px; color:#4a4a4a;" v-show="volume == 0"></i>
            <i class="icon-voice" style="font-size:24px; color:#4a4a4a;" v-show="volume > 0"></i>
          </div>
          <div class="volume_change">
            <el-slider style="-webkit-transform:scale(0.55);width:270px;left:-60px;position:relative;" v-model="volume" @change="handleVolumeChange" :step='1'></el-slider>
          </div>
          <div class="volume_show">{{volume}}</div>
        </div>
      </div>
      <audio id="audio-bgm-material" :src="audio_player" loop></audio>
    </div>

    <!-- 公共市场列表 -->
    <div class="public" :class="{position_top: music_play_status && tab_category_init == 'bgm'}" v-show="!theme_show">
      <div class="breadcrumb clearfix">
          <span v-show="breadcrumb.length > 1"
                v-for="item, index in breadcrumb"
                @click="handleTargetNav(index, item.folder_id,'')">{{'/ ' + item.name}}</span>
        </div>
      <!-- 左侧分类   -->
      <div class="category-type" v-show="!search_status && tab_left_pancel.length != 1">
        <div v-for="item, index in tab_left_pancel" :class="{'active':item.active}" @click="handleLeftPancelChange(index)">
          <span>{{item.name}}</span>
        </div>
      </div>
      <!-- 列表数据 -->
      <div class="list-wrapper" :class="hideLeft" v-show="!no_result">
        <ul class="list clearfix" v-if="tab_left_pancel_init != 'bgc'">
          <li :class="[tab_category_init == 'bgm' ? 'item-bgm' : 'item', publicList]" v-for="item, index in public_list_data" v-if="this.tab_left_pancel_init = 'buy'" v-show="item.count != 0" @mousedown="handlePublicItemDown(item, $event)"  @mouseup="handlePublicItemUp(item, $event)">

            <div class="inner">
              <!-- 音乐类型 -->
              <template v-if="tab_category_init == 'bgm'">
                <div class="pic"><img src="../Bgm/music.png"></div>
                <div class="text">
                  <div class="name"><span>{{item.title}}</span><span class="tips" v-if="tab_tab_init == 'public'">免费</span></div>
                  <div class="desc" :title="item.copyright">{{item.copyright}}</div>
                </div>
              </template>
              
              <!-- 其他类型 -->
              <template v-else>
                <div class="pic folder" v-if="item.type == 'folder' | item.type == 'package'" v-show="tab_category_init != 'material' && tab_category_init != 'prop'"><img src="./material_scene_file.png" style="width:100%;height:100%;margin:0 auto;"></div>
                <div class="pic folder" v-if="item.type == 'folder' | item.type == 'package'" v-show="tab_category_init == 'material' || tab_category_init == 'prop'"><img src="./material_person_file.png" style="width:64px;height:60px;padding:0;"></div>
                <div class="pic padding" v-if="item.type != 'folder' && item.type != 'package'"  v-show="tab_category_init != 'scene' && tab_category_init != 'material' && tab_category_init != 'prop'" ><img  :src="tab_tab_init === 'public' ? item.thumb : item.preview"  :onerror="img_default"></div>
                <div class="pic padding" v-if="item.type != 'folder' && item.type != 'package' && (tab_category_init == 'material' || tab_category_init == 'prop')"  v-show="tab_tab_init === 'public' ? item.thumb : item.preview" ><img  :src="tab_tab_init === 'public' ? item.thumb : item.preview" :onerror="img_default"></div>
                <div class="pic padding" v-if="item.type != 'folder' && item.type != 'package' && (tab_category_init == 'material' || tab_category_init == 'prop')"  v-show="!(tab_tab_init === 'public' ? item.thumb : item.preview)"><img  style="width:33px;height:30px;margin:0 auto;" src="./default_person.png"></div>
                <div class="pic" v-if="item.type != 'folder' && item.type != 'package'" v-show="tab_category_init == 'scene' && (tab_tab_init === 'public' ? item.thumb : item.preview)" ><img :src="tab_tab_init === 'public' ? item.thumb : item.preview" :onerror="img_default"></div>
                <div class="pic" v-if="item.type != 'folder' && item.type != 'package'" v-show="tab_category_init == 'scene' && !(tab_tab_init === 'public' ? item.thumb : item.preview)"><img  src="./default_scene.png"></div>
                <div class="text" v-if="item.type != 'folder' && item.type != 'package'">
                  <div class="name" :title="item.title">{{item.title}}</div>
                  <div class="desc" v-if="item.type != 'folder' && item.type != 'package'" :title="item.copyright">{{item.copyright}}</div>
                  <div class="tip" v-if="tab_tab_init == 'public'">免费</div>
                </div>

                <div class="text" v-if="item.type == 'folder' || item.type == 'package'" style="background:#505050;">
                  <div class="name" style="color:#e2e2e2;" :title="item.title">{{item.title}}</div>
                  <div class="desc">&nbsp</div>
                  <div class="tip" v-if="tab_tab_init == 'public'">免费</div>
                </div>
              </template>
            </div>
          </li>
        </ul>

        <el-button v-if="tab_left_pancel_init == 'bgc'" v-show="!color_type" @click="color_type = true" size="small" style="margin:0;float:right;margin-right:10px;background:#4a9f95;color:#fff;">简易</el-button>
        <el-button v-if="tab_left_pancel_init == 'bgc'" v-show="color_type" @click="color_type = false" style="margin:0;float:right;margin-right:10px;background:#4a9f95;color:#fff;" size="small">高级</el-button>
        <ul class="list clearfix color" id="color" v-if="tab_left_pancel_init == 'bgc'">
          <li v-if="color_type" v-for="item in colors" :style="{background: item}" @click="handleColorChange(item)"></li>
          <photoshop v-if="!color_type" v-model="colors_a" />
          <el-button v-if="!color_type" style="margin:0;float:right;margin-right:10px;background:#4a9f95;color:#fff; " size="small" @click="colorSubmit()">确认</el-button>
        </ul>

         <!-- 分页控件的占位高度 -->
        <div style="position:relation:width:100%;height:20px;"></div>
      </div>
       <!-- 分页控件 -->
        <div class="loadMore" v-show="tab_left_pancel_init != 'bgc'" v-if="!no_result">
            <el-pagination class="pagination" small
              @current-change="handleCurrentChange"
              :page-size="20"
              :pager-count="5"
              layout="prev, pager, next"
              :total="pagination_list_count" >
            </el-pagination>
        </div>
    </div>

    <!-- 主题详情列表 -->
    <div class="theme-detail" v-show="theme_show">
      <el-button type="text" size="mini" icon="el-icon-arrow-left" style="color:#666;" @click="handleGoBack()">上一页</el-button>
      <!--场景-->
      <el-collapse v-model="activeNames" accordion>
        <el-collapse-item :title="'场景(' + theme.scene.length  + ')' " name="1">
          <div class="theme-item">
            <div class="title1"></div>
            <div class="item" v-for="item, index in theme.scene" @click="handleThemeChangeDetail(item, 'scene')">
              <div class="inner">
                <div class="pic" v-if="tab_tab_init === 'public' ? item.thumb : item.preview"><img :src="tab_tab_init === 'public' ? item.thumb : item.preview" :onerror="img_default"></div>
                <div class="pic" v-else><img src="./default_scene.png"></div>
                <div class="text">
                  <div class="name" :title="item.title">{{item.title}}</div>
                  <div class="desc" :title="item.copyright">{{item.copyright}}</div>
                  <div class="tip">免费</div>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <!-- 形象 -->
        <el-collapse-item :title=" '形象(' + theme.material.length + ')' "  name="2">
          <div class="theme-item">
            <div class="item" v-for="item, index in theme.material" @click="handleThemeChangeDetail(item, 'material')">
              <div class="inner">
                <div class="pic padding" v-if="tab_tab_init === 'public' ? item.thumb : item.preview"><img :src="tab_tab_init === 'public' ? item.thumb : item.preview" :onerror="img_default"></div>
                <div class="pic padding" v-else><img style="width:33px;height:30px;margin:0 auto;" src="./default_person.png"></div>
                <div class="text">
                  <div class="name" :title="item.title">{{item.title}}</div>
                  <div class="desc" :title="item.copyright">{{item.copyright}}</div>
                  <div class="tip">免费</div>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <!-- 道具 -->
        <el-collapse-item :title=" '道具(' + theme.prop.length + ')'" name="3">
          <div class="theme-item">
            <div class="item" v-for="item, index in theme.prop" @click="handleThemeChangeDetail(item, 'prop')">
              <div class="inner">
                <div class="pic padding" v-if="tab_tab_init === 'public' ? item.thumb : item.preview"><img :src="tab_tab_init === 'public' ? item.thumb : item.preview" :onerror="img_default"></div>
                <div class="pic padding" v-else><img style="width:33px;height:30px;margin:0 auto;" src="./default_person.png"></div>
                <div class="text">
                  <div class="name" :title="item.title">{{item.title}}</div>
                  <div class="desc" :title="item.copyright">{{item.copyright}}</div>
                  <div class="tip">免费</div>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <!-- 没有结果 -->
    <div class="no_results" v-show="no_result">
      <div class="pic">
        <img src="./no_result.png">
      </div>
      <div class="text" style="color:#fff;">暂时还没有内容呦~^-^~</div>
    </div>
    <!-- 通讯组件  psocket-->
    <psocket :attributes="attributes" :flashvars="flashvars" v-if="platform == 'qt'"/>
  </div>
</template>
<script>
  // Psocket 组件
  import Psocket from '@/components/Flash/PSocket'
  // 通讯协议
  import Protocol from '@/common/scripts/protocol.js'
  // 工具类
  import EUY from '@/common/scripts/euy.js'
  import BScroll from 'better-scroll'
  import  {Photoshop}  from 'vue-color'
  import {eventBus} from '@/common/scripts/eventBus.js'
  export default {
    name:"material",
    // 组件
    components: {
      Psocket,
      Photoshop
    },

    // 数据
    data () {
      return {
        platform: this.$route.query.platform,
        img_default :  'this.src="' + require('./error.png') + '"'
        ,
        colors: [
          '#9a2020', '#b72a33', '#e33633', '#e56364', '#360d46', '#4d1767', '#632580', '#9148b2',
          '#335876', '#507c9e', '#689bc5', '#7fb2da', '#638637', '#86ae50', '#85c050', '#ade06e',
          '#c18035', '#dc9f49', '#edab54', '#f1c07f', '#ba9333', '#d7b840', '#e7d056', '#f6e077',
          '#000000', '#2a2a2a', '#474646', '#6f6f6f', '#909090', '#b5b4b4', '#dadada', '#ffffff',
        ],
        loading: false,
        tab_type: '',

        // 主题默认打开
        activeNames: ['1'],
        // ------------------------------------------------- [ FLASH ] -------------------------------------------------

        // SWF 初始化配置
        flashvars: {
          module: MATERIAL_NAME
        },
        attributes: {
          id: MATERIAL_NAME + '-PSOCKET',
          class: 'psocket',
        },
        // ----------------------------------------------------[ 搜索 ]---------------------------------------------
        search_key: '',
        no_result: false,
        // -------------------------------------------------- [ 标签切换 ] --------------------------------------------------
        select_prop : '',
        // 数据
        tab_tab: [],
        // 初始值
        tab_tab_init: 'public',

        // 素材分类
        tab_category: [
          { name: '模板', active: false, type: 'template' },
          { name: '主题', active: false, type: 'theme'},
          { name: '场景', active: true, type: 'scene' },
          { name: '形象', active: false, type: 'material'},
          { name: '道具', active: false , type: 'prop'},
          { name: '音乐', active: false, type: 'bgm'},
        ],
        //编辑器素材 动作编辑器的情况
        tab_category_action : [
            { name: '形象', active: true, type: 'material' },
            { name: '道具', active: false , type: 'prop'}
        ]
        ,
        // 初始值
        tab_category_init: 'scene',
        // 左侧分类
        tab_left_pancel: [],
        // 初始值
        tab_left_pancel_init: '',

        // -------------------------------------[ 列表数据 ]--------------------------------
        public_list_data: [],
        self_list_data: [],
        team_list_data: [],
        // 我的--团队--文件夹
        breadcrumb: [
          { name: '根文件夹', folder_id: '/' }
        ],
        //  ------------------------------------[ 分页数据 ]-----------------------------
        current_page: 1,
        page_size: 20,
        total: 0,
        more: false,
        // ----------------------------------------【 其他数据 】------------------------
        // p平台
        platform_type: '',
        // 公共市场-->分类id
        category_id: '',
        // 团队ID
        team_id: '',
        // 文件夹id
        folder_id: '',
        // 主题数据
        theme: {
          material: [],
          prop: [],
          bgm: [],
          scene: []
        },
        // 主题列表状态
        theme_show: false,
        // 音乐播放地址
        audio_player: '',
        // 音乐播放器声音
        volume: 0,
        // 播放按钮
        audio_tips: '暂停',
        // 音乐标题
        bgm_title: '',
        // 音乐播放状态
        play_status: false,
        // 音乐播放器显示状态
        music_play_status: false,

        collect_time: null,
        ops_id: '',
        has_token: '',
        has_user_id:'',
        // 遮罩层
        mask_visible: false,
        search_status: false,
        listColor: [],
        colors_a: {
          hex: '#194d33',
          hsl: {
            h: 150,
            s: 0.5,
            l: 0.2,
            a: 1
          },
          hsv: {
            h: 150,
            s: 0.66,
            v: 0.30,
            a: 1
          },
          rgba: {
            r: 25,
            g: 77,
            b: 51,
            a: 1
          },
          a: 1
        },
        color_type: true,

        team_name: '',

        self_name: '',

        // 分页组件数据总数
        pagination_list_count:0,
      }
    },
    methods: {
      // 搜索组件获得焦点
      searchInputFocus(){
          this.search_key=' '
      },
      searchInputBlur(){
          this.search_key=''
      },
      handleColorChange (item){
          this.handleColor(item)
      },
      handleColor (item) {
        let  platform = this.$route.query.platform
        // protobuf 打包
        let MMaterial  = new proto.com.proto.material.MMaterial()
        let MMaterialType = 'scene'
        // protobuf 打包格式
        MMaterial.setType(MMaterialType)
        MMaterial.setId(item)
        // protobuf 序列化
        let protoBytes = MMaterial.serializeBinary()

        // Uint8Array 转换 Array
        let protoBytesArray = Array.from(protoBytes)
        let material_scene_3_1 = {
          packageId: 0,
          senderId: MATERIAL,
          senderName: MATERIAL_NAME,
          receiverId: SCENE,
          receiverName: SCENE_NAME,
          timeFlag: new Date().getTime(),
          sessionId: 3,
          messageId: 1,
          protoBytesType: 'proto.com.proto.material.MMaterial',
          protoBytes: protoBytesArray
        }
        // 发送消息
        Protocol.sender(platform, material_scene_3_1)
      },
      // ----------------------------------------[ tab切换 ]---------------------------------------
      // 公共市场--我的--团队切换
      handleTabChange (index)
      {
          this.changeTab(index, this.tab_tab)
          this.tab_tab_init = this.tab_tab[index].type
          this.tab_category_init = 'scene'
          this.tab_left_pancel_init = ''
          console.log('tab_tab_init====>' + this.tab_tab_init)
          if(this.tab_tab_init == 'self'){
              // 素材分类
              this.tab_category = [
                  { name: '模板', active: false, type: 'template' },
                  { name: '场景', active: true, type: 'scene' },
                  { name: '形象', active: false, type: 'material' },
                  { name: '道具', active: false , type: 'prop'},
                  { name: '组件', active: false , type: 'component'},
                  { name: '音乐', active: false , type: 'bgm'},
              ]
              //动作编辑器情况
              if(2 ==  this.tab_type ) {
                  this.tab_category =  this.select_prop == '' ?  this.tab_category_action : this.select_prop
                  this.tab_category_init = this.select_prop == '' ? 'material' : 'prop'
              }
              // 场景编辑器
              else if (3 == this.tab_type){
                  // this.tab_category =  this.select_prop == '' ?  this.tab_category_action : this.select_prop
                  this.tab_category_init = 'prop'
                  this.tab_category = this.tab_category = [
                      { name: '形象', active: false, type: 'material' },
                      { name: '道具', active: true , type: 'prop'},
                      { name: '音乐', active: false, type: 'bgm'}
                  ]
              }
              // 目录清空
              this.breadcrumb = [
                  { name: this.self_name, folder_id: '/' }
              ]
              // console.log("我的  "  + JSON.stringify(this.breadcrumb))
          }else if(this.tab_tab_init == 'team') {
              // 素材分类
              this.tab_category = [
                  { name: '模板', active: false, type: 'template' },
                  { name: '场景', active: true, type: 'scene' },
                  { name: '形象', active: false, type: 'material' },
                  { name: '道具', active: false , type: 'prop'},
                  { name: '组件', active: false , type: 'component'},
                  { name: '音乐', active: false , type: 'bgm'},
              ]
              //动作编辑器情况
              if(2 ==  this.tab_type) {
                  this.tab_category =  this.select_prop == '' ?  this.tab_category_action : this.select_prop
                  this.tab_category_init = this.select_prop == '' ? 'material' : 'prop'
              }
              // 场景编辑器
              else if (3 == this.tab_type){
                  // this.tab_category =  this.select_prop == '' ?  this.tab_category_action : this.select_prop
                  this.tab_category_init = 'prop'
                  this.tab_category = this.tab_category = [
                      { name: '形象', active: false, type: 'material' },
                      { name: '道具', active: true , type: 'prop'}
                  ]
              }
              // 目录清空
              this.breadcrumb = [
                  { name: this.team_name, folder_id: '/' }
              ]
              console.log("团队")
          }else if(this.tab_tab_init == 'public'){
              // 素材分类
              this.tab_category = [
                  { name: '模板', active: false, type: 'template' },
                  { name: '主题', active: false, type: 'theme'},
                  { name: '场景', active: true, type: 'scene' },
                  { name: '形象', active: false, type: 'material' },
                  { name: '道具', active: false , type: 'prop'},
                  { name: '音乐', active: false , type: 'bgm'},
              ]
              //动作编辑器情况
              if(2 ==  this.tab_type) {
                  this.tab_category =  this.select_prop == '' ?  this.tab_category_action : this.select_prop
                  this.tab_category_init = this.select_prop == '' ? 'material' : 'prop'
              }
              // 场景编辑器
              else if (3 == this.tab_type){
                  // this.tab_category =  this.select_prop == '' ?  this.tab_category_action : this.select_prop
                  this.tab_category = [
                      { name: '形象', active: false, type: 'material' },
                      { name: '道具', active: true , type: 'prop'},
                      { name: '背景色', active: false, type: 'bgc' },
                      { name: '音乐', active: false, type: 'bgm'}
                  ]
                  this.tab_category_init = 'prop'
              }
              // 目录清空
              this.breadcrumb = [
                  { name: this.team_name, folder_id: '/' }
              ]
              console.log("公共市场" + this.tab_category_init)
          }
          // 文件夹id清空
          this.folder_id = ''
          // 主题列表隐藏
          this.theme_show = false
          // 更新左侧列表数据
          this.handleGetCategoryList(this.tab_category_init)
          // 更新列表数据
          this.handleMaterialListData(this.tab_category_init, this.page_size, this.current_page, this.category_id, this.folder_id, this.team_id, this.search_key)
      },

      // 主题--形象--场景--道具切换
      handleCategoryChange (index)
      {
        // this.search_key = ''
          console.log("主题--形象--场景--道具-组件 切换" + index);
        // 主题列表隐藏
        this.theme_show = false
        // 防止重复点击
        if(this.tab_category_init != this.tab_category[index].type) {
          // 样式更改
          this.changeTab(index, this.tab_category)
          // category状态赋值
          this.tab_category_init = this.tab_category[index].type
          this.tab_left_pancel_init = ''
          // 分类id赋值
          this.category_id = ''
          // 更新左侧列表数据
          this.handleGetCategoryList(this.tab_category_init)
          // 数据重置
          this.current_page = 1
          // 页数问题
          this.pagination_list_count = 0
          this.public_list_data = []
          if(this.tab_tab_init == 'self'){
          // 目录清空
          this.breadcrumb = [
            { name: this.self_name, folder_id: '/' }
          ]
        }
        if(this.tab_tab_init == 'team') {
          // 目录清空
          this.breadcrumb = [
            { name: this.team_name, folder_id: '/' }
          ]
        }

          this.folder_id = ''
          if (this.tab_tab_init == 'public' && this.tab_category[index].type == 'bgc'){
              this.loading = false
              this.more = false
              this.no_result = false
              this.tab_left_pancel_init = this.tab_category[index].type
          }
          else{
              // 更新列表数据
              this.handleMaterialListData(this.tab_category_init, this.page_size, this.current_page, this.category_id, this.folder_id, this.team_id, this.search_key)
              console.log(this.tab_category_init, this.page_size, this.current_page, this.category_id, this.folder_id, this.team_id, this.search_key)
          }

        }
      },
      // 素材分类切换
      handleLeftPancelChange (index)
      {
        if(this.tab_left_pancel_init != this.tab_left_pancel[index].id){
            // 目录清空
            this.breadcrumb = [
                { name: this.self_name, folder_id: '/' }
            ]

          // 样式更改
          this.changeTab(index, this.tab_left_pancel)
          // category状态赋值
          this.tab_left_pancel_init = this.tab_left_pancel[index].id
          // 分类id赋值
          let leftId = this.tab_left_pancel[index].id
          if(typeof leftId == 'number') {
            this.category_id = leftId
          }else{
            this.category_id = ''
          }
          // 数据重置
          this.current_page = 1
          this.public_list_data = []
          // 更新列表数据
          this.handleMaterialListData(this.tab_category_init, this.page_size, this.current_page, this.category_id, this.folder_id, this.team_id, this.search_key)

            //console.log(this.tab_category_init, this.page_size, this.current_page, this.category_id, this.folder_id, this.team_id, this.search_key)
        }
      },
      // 切换公共方法
      changeTab(index, data)
      {
        for (let i = 0; i < data.length; i++) {
          data[i].active = false
        }
        data[index].active = true
      },
      // -----------------------------------[ 搜索 ]-------------------------------------------
      // 开始搜索
      handdleStartSearch ()
      {
        this.search_status = true
        // 公共市场--我的--团队 数据清空
        this.public_list_data = []
        this.self_list_data = []
        this.team_list_data = []
        this.current_page = 1
        this.pagination_list_count = 0
        // 清空文件路径
        this.breadcrumb = [{ name: this.self_name, folder_id: '/' }]
        // // 更新列表数据
        this.handleMaterialListData(this.tab_category_init, this.page_size, this.current_page, this.category_id, this.folder_id, this.team_id, this.search_key)
      },
      // 关闭搜索
      handleCloseSearch ()
      {
        this.search_key = ''
        // 更新列表数据
        this.handdleStartSearch()
        this.search_status = false
      },
      // 加载更多
      handleMore ()
      {
        this.current_page ++
        // 更新列表数据
        this.handleMaterialListData(this.tab_category_init, this.page_size, this.current_page, this.category_id, this.folder_id, this.team_id, this.search_key)
      },
      // -------------------------------------------------[ 单条数据操作 ]---------------------------------------
      // 鼠标按下
      handlePublicItemDown (item, ev) {

        if(ev.button == 2){
          document.oncontextmenu=function(){
            return false
          }
        }
          this.collect_time = setTimeout(() => {
            if(this.tab_left_pancel_init == 'collect'){
              this.ops_id = item.matter_id
            }else{
              this.ops_id = item.id
            }
            if('public' == this.tab_tab_init) {
              if(item.isFav) {
              this.dialog_cancel_collect_visible = true
              eventBus.$emit('dialogOpen',{'dialog_cancel_collect_visible':true,'component_name':'material'});
              }else {
                this.dialog_collect_visible = true
                eventBus.$emit('dialogOpen',{'dialog_collect_visible':true,'component_name':'material'});
              }
            }
          },1000)
      },

      // 鼠标抬起
      handlePublicItemUp (item, ev)
      {
        if(ev.button == 2) {
            document.oncontextmenu=function(){
            return false
          }
        }else {
          // alert('left')
          clearInterval(this.collect_time)
          
          // 音乐类型：播放音乐
          if(this.tab_category_init == 'bgm'){
            this.handleItemPlayBgm(item);
            return null;
          }
          
          if(this.tab_category_init == 'theme'){
            this.theme_show = true
            this.handleGetThemeDetailData(item.id)
            return null
          }else{
              if (this.tab_tab_init == 'public') {

                console.log(' bbbbb ===> ' + JSON.stringify(item))
                let id = (item.dataId && item.dataId.length>0)?item.dataId:item.oriDataId
                this.handleChangeMaterial(this.tab_category_init, id)
              } else {
                if(item.type == "folder") {
                  this.folder_id = item.id
                  this.breadcrumb.push({'name':item.title,'folder_id':item.id})
                  this.handleTargetNav(this.breadcrumb.length,item.id,'folder');
                }
                // 购买的素材 有的package类型
                else if(item.type == "package"){
                    this.breadcrumb.push({'name':item.title,'folder_id':item.packageId})
                    this.folder_id = item.packageId
                    if (this.tab_tab_init == 'team'){
                        this.handleGetPackageDataTeam (this.tab_category_init, this.search_key, this.current_page, this.page_size, this.team_id, item.packageId)
                    }else if (this.tab_tab_init == 'self'){
                        this.handleGetPackageDataSelf (this.tab_category_init, this.search_key, this.current_page, this.page_size, item.packageId)
                    }

                }
                else {
                    // 我购买的用 item.oriDataId ,我 创建的item.id
                    let cacheId = ''
                    if(this.tab_left_pancel_init == 'creat'){
                      cacheId = item.id;
                    }
                    else if (this.tab_left_pancel_init == 'buy'){
                      cacheId = item.dataId
                    }
                    this.handleChangeMaterial(this.tab_category_init, cacheId)
                    // console.log('cccccccmmmmmmmmm' + JSON.stringify(item) + this.tab_category_init + cacheId)
                }
              }
            return null
          }
        }
      },

      // 主题点击返回
      handleGoBack () {
        this.theme_show = false
      },
      // 我的
      handleSelfTeamItem (item) {
        if(item.type == 'folder'){
          let name = item.title
          this.folder_id = item.id
          this.breadcrumb.push({
            name: name,
            folder_id: this.folder_id
          })
          this.handleCloseSearch()
        }else{
          if(this.tab_category_init == 'theme'){
            this.theme_show = true
            this.handleGetThemeDetailData(item.id)
          }else{
              this.handleChangeMaterial(this.tab_category_init, item.id)


          }
        }
      },
      // 目录跳转
      handleTargetNav(index, folder_id, handleType) {
        this.current_page = 1
        let arr = []
        for (let i = 0; i < this.breadcrumb.length; i++) {
          if (i <= index) {
            arr.push(this.breadcrumb[i])
          }
        }
        this.breadcrumb = arr

        if (folder_id == '/') {
          this.folder_id = ''
          // 更新列表数据
          this.handleMaterialListData(this.tab_category_init, this.page_size, this.current_page, this.category_id, this.folder_id, this.team_id, this.search_key)
        } else {
            this.folder_id = folder_id
            if(this.tab_left_pancel_init == 'creat'){
                // 更新列表数据
                this.handleMaterialListData(this.tab_category_init, this.page_size, this.current_page, this.category_id, this.folder_id, this.team_id, this.search_key)
            }else  if (this.tab_left_pancel_init == 'buy'){
                // 点击面包屑
                if (handleType == ''){
                    // 如果是最后的一级目录就不掉用了
                    if (folder_id == this.breadcrumb[this.breadcrumb.length - 1].folder_id) {
                    }
                    // 购买的文件里不会在有文件夹,所以暂不考虑多级目录的情况
                    // else{
                    //
                    // }
                }
                // 点击文件夹
                else if (handleType == 'folder'){
                    // 更新列表数据
                    this.handleMaterialListData(this.tab_category_init, this.page_size, this.current_page, this.category_id, this.folder_id, this.team_id, this.search_key)
                }
            }
        }

      },
      // -------------------------------------------------[  api  ]-----------------------------------------------
      // 列表同意处理
      handleMaterialListData (type, page_size, current_page, category_id, folder_id, team_id, search_key) {
        this.loading = true
        this.more = false
        console.log('handleMaterialListData === ' + this.tab_tab_init, this.tab_left_pancel_init, type, page_size, current_page, category_id, folder_id, team_id, search_key)
        if(type == 'material' || type == 'prop') page_size = 21
        // 公共市场
        if(this.tab_tab_init == 'public'){
          if(this.tab_left_pancel_init == 'collect'){
            this.handleGetPublicMaterialFavoriteListDate(type, page_size, current_page, search_key)
          }
          // 背景色
          else if(this.tab_left_pancel_init == 'bgc'){
            this.loading = false
            this.more = false
            this.no_result = false
          }
          // 其他
          else{
            this.handleGetPublicMaterialListDate(type, page_size, current_page, category_id, search_key)

          }
        }

        // 我的
        if(this.tab_tab_init == 'self'){

          if(this.tab_left_pancel_init == 'creat'){

            this.handleGetSelfMaterialListDate(type, page_size, current_page, folder_id, search_key)
          }
          if(this.tab_left_pancel_init == 'buy'){
              if (search_key.length > 0 | this.current_page > 1){
                  this.handleGetPackageDataSelf (type, search_key, current_page, page_size,folder_id)
              }else{
                  this.handleGetBuyListData(type, page_size, current_page, search_key, '', folder_id)
              }

          }

        }
        // 团队
        if(this.tab_tab_init == 'team'){

          if(this.tab_left_pancel_init == 'creat'){

            this.handleGetTeamMaterialListData(type, page_size, current_page, folder_id, team_id, search_key)
          }
          if(this.tab_left_pancel_init == 'buy'){
            // this.handleGetPackageDataTeam (type, search_key, current_page, page_size, team_id)
              if (search_key.length > 0 | this.current_page > 1 ){
                  this.handleGetPackageDataTeam (type, search_key, current_page, page_size, team_id)
              }else{
                  this.handleGetBuyListData (type, page_size, current_page, search_key, team_id, folder_id)
              }

          }
        }
      },

      // 素材列表-->公共市场
      handleGetPublicMaterialListDate (type, page_size, current_page, category_id, search_key) {

        let URL = process.env.HOST + '/api/storage/market/matters'

        let headers = {
          'Authorization': this.has_token
        }

        let params = {
          'type': type,
          'pageSize': page_size,
          'page': current_page,
          'categoryId': category_id,
          'keyword': search_key
        }
        this.AJAX.get(URL, headers, params).then((data)=>{
          // console.log('素材列表-->公共市场 ===> '+JSON.stringify(data))
          if(data.code === 10000){
            // 分页数据总数
            let total = data.datas.total
            this.pagination_list_count = total
            // this.pagination_list_count = data.result.page.total
          }
          // setTimeout(() => {
          //   this.loading = false
          // }, 500)
          this.loading = false
          // 第一页数据为空
            if(current_page == 1 && data.datas.rows.length == 0){
              this.no_result = true
              this.more = false
            }
            // 正常数据处理
            else{
              this.no_result = false
              this.public_list_data = data.datas.rows
              if(data.datas.rows.length >= this.page_size) {
                this.more = true
                return false
              }else{
                this.more = false
                return false
              }
            }
        }).catch((err)=>{
          debugger
            this.$message({
              message: err.msg||err.message,
              type: 'error'
            })
        })
      },
      // 素材列表-->公共市场-->收藏
      handleGetPublicMaterialFavoriteListDate (type, page_size, current_page, search_key) {
        let URL = process.env.HOST + '/api/storage/market/matters/favorites'
        let headers = {
          'Authorization': this.has_token
        }
        let params = {
          'type': type,
          'page': current_page,
          'pageSize': page_size,
          'keyword': search_key
        }

        this.AJAX.get(URL, headers, params).then((data)=>{

          if(data.code == 10000) {
            // 分页数据总数
            let total = data.datas.total
            this.pagination_list_count = total
          }
          setTimeout(() => {
            this.loading = false
          }, 0)
          // 第一页数据为空
            if(current_page == 1 && data.datas.rows.length == 0){
              this.no_result = true
              this.more = false
            }else { // 正常数据处理
              this.no_result = false
              this.public_list_data = data.datas.rows
              if(data.datas.rows.length >= this.page_size) {
                this.more = true
                return false
              }else{
                this.more = false
                return false
              }
            }
        }).catch((err)=>{
          debugger
            this.$message({
              message: err.msg||err.message,
              type: 'error'
            })
        })
      },
      // 素材市场-->我的
      handleGetSelfMaterialListDate (type, page_size, current_page, folder_id, search_key) {
        let URL = process.env.HOST + '/api/storage/storage/resource/v1/list'

        let headers = {
          'Authorization': this.has_token
        }

        let params = {
          'type': type,
          'page': current_page,
          'pageSize': page_size,
          'folderId': folder_id,
          'keyword': search_key
        }

        this.AJAX.get(URL, headers, params).then((data)=>{
          setTimeout(() => {
            this.loading = false
          }, 0)
          if(data.code === 10000){
            // 分页数据总数
            let total = data.datas.total
            this.pagination_list_count = total
            // 第一页数据为空
            if(current_page == 1 && data.datas.rows.length == 0){
              this.no_result = true
              this.more = false
            }
            // 正常数据处理
            else{
              this.no_result = false
              this.public_list_data = data.datas.rows
              if(data.datas.rows.length >= this.page_size) {
                this.more = true
                return false
              }else{
                this.more = false
                return false
              }
            }
          }else {
            this.$message({
              message: data.message,
              type: 'error'
            })
          }
        }).catch((err)=>{

          debugger
            this.$message({
              message: err.msg||err.message,
              type: 'error'
            })
        })
      },

      // 素材市场-->团队
      handleGetTeamMaterialListData (type, page_size, current_page, folder_id, team_id, search_key) {

        let URL = process.env.HOST + '/api/storage/storage/resource/v1/list'
        let headers = {
          'Authorization': this.has_token
        }
        let params = {
          'type': type,
          'page': current_page,
          'pageSize': page_size,
          'folderId': folder_id,
          'keyword': search_key,
          'teamId': team_id
        }
        this.AJAX.get(URL, headers, params).then((data)=>{
          setTimeout(() => {
            this.loading = false
          }, 0)
          if(data.code === 10000){
            // 分页数据总数
            let total = data.datas.total
            this.pagination_list_count = total
            // 第一页数据为空
            if(current_page == 1 && data.datas.rows.length == 0){
              this.no_result = true
              this.more = false
            }
            // 正常数据处理
            else{
              this.no_result = false
              this.public_list_data = data.datas.rows

              if(data.datas.rows.length >= this.page_size) {
                this.more = true
                return false
              }else{
                this.more = false
                return false
              }
            }
          }else {
            this.$message({
              message: data.message,
              type: 'error'
            })
          }
        }).catch((err)=>{
          debugger
            this.$message({
              message: err.msg||err.message,
              type: 'error'
            })
        })
      },

        //  我的／团队 购买的
        handleGetBuyListData (type, page_size, current_page, search_key, team_id, folder_id) {
          let URL = process.env.HOST + '/api/storage/market/packages/purchased'
          let headers = {
            'Authorization': this.has_token
          }
          var params = {
            'type': type,
            'page': current_page,
            'pageSize': page_size,
            'keyword': search_key,
            'teamId': team_id,
            'folderId': folder_id
          }

           // console.log("请求的参数 =>" + URL + ',' + JSON.stringify(params)+ ',' + JSON.stringify(headers) )
            this.AJAX.get(URL, headers, params).then((data)=>{
                if(data.code == 10000){
                   // 分页数据总数
                  this.pagination_list_count = data.datas.total
                }
                setTimeout(() => {
                    this.loading = false
                }, 0)
                // 第一页数据为空
                if(current_page == 1 && data.datas.rows.length == 0){
                    this.no_result = true
                    this.more = false
                }
                // 正常数据处理
                else{

                    this.no_result = false
                    // 第一页数据特殊处理
                    if(current_page == 1){
                        var count = 0
                        for (var i = 0;i < data.datas.rows.length;i ++){
                            if (data.datas.rows[i].count == 0){
                                count += 1
                            }
                        }
                        if (count == data.datas.rows.length){
                            this.no_result = true
                        }
                        this.public_list_data = data.datas.rows
                    }
                    // 加载更多正常处理
                    else{
                        this.public_list_data = this.public_list_data.concat(data.datas.rows)
                    }

                    if(data.datas.rows.length >= this.page_size) {
                        this.more = true
                        return false
                    }else{
                        this.more = false
                        return false
                    }
                }
            }).catch((err)=>{
              debugger
                this.$message({
                    message: err.msg||err.message,
                    type: 'error'
                })
            })
        },

      // 获取素材分类列表
      handleGetCategoryList (type) {
          console.log('handleGetCategoryList ==> ' + type)
          if(this.tab_tab_init == 'self'){

            this.handleGetSelfPackageStatus()
          }
          if(this.tab_tab_init == 'team'){

            this.handleGetTeamPackageStatus(this.team_id)
          }
          if(this.tab_tab_init == 'public'){
            let URL = process.env.HOST + '/api/storage/market/categories'

            let headers = {
              'Authorization': this.has_token
            }

            let params = {
              'type': type
            }

            this.AJAX.get(URL, headers, params).then((data)=>{
              // 初始左侧导航赋值
                this.tab_left_pancel = [
                  {
                    'name': '所有',
                    'active': true,
                    'id': ''
                  },
                  {
                    'name': '收藏',
                    'active': false,
                    'id': 'collect'
                  }
                ]
                // 主题分类
                if(type == 'theme'){
                }
                // 场景分类
                if(type == 'scene'){
                  this.tab_left_pancel = [
                    {
                    'name': '所有',
                    'active': true,
                    'id': ''
                  },
                  {
                    'name': '收藏',
                    'active': false,
                    'id': 'collect'
                  },
                  {
                    'name': '背景色',
                    'active': false,
                    'id': 'bgc'
                  }
                ]
                  for(var i=0;i<data.datas.rows.length;i++){
                    data.datas.rows[i].active = false
                  }
                  this.tab_left_pancel = this.tab_left_pancel.concat(data.datas.rows)
                }
                // 形象分类
                if(type == 'material'){
                  for(var i=0;i<data.datas.rows.length;i++){
                    data.datas.rows[i].active = false
                  }
                  this.tab_left_pancel = this.tab_left_pancel.concat(data.datas.rows)
                }

                // 道具分类
                if(type == 'prop'){
                  for(var i=0;i<data.datas.rows.length;i++){
                    data.datas.rows[i].active = false
                  }
                  this.tab_left_pancel = this.tab_left_pancel.concat(data.datas.rows)
                }

                // 道具分类
                if(type == 'anim'){
                  for(var i=0;i<data.datas.rows.length;i++){
                    data.datas.rows[i].active = false
                  }
                  this.tab_left_pancel = this.tab_left_pancel.concat(data.datas.rows)
                }

                // 背景色分类去掉左边栏
                if(type == 'bgc'){
                    this.tab_left_pancel = []
                }
            })
          }


      },
      // 更换素材
      handleChangeMaterial(type, id) {
        let  platform = this.$route.query.platform
        let  _this = this
        // protobuf 打包
        let MMaterial  = new proto.com.proto.material.MMaterial()
        let MMaterialType = null
        if (type == 'scene') {
          MMaterialType = 'scene'
        }
        if (type == 'material') {
          MMaterialType = 'material'
        }
        if (type == 'prop') {
          MMaterialType = 'prop'
        }
        if (type == 'bgm') {
          MMaterialType = 'bgm'
        }
        if(type == 'template' || type == 'anim'){
          MMaterialType = 'anim'
        }else if(type == 'component'){
          MMaterialType = 'component'
        }

        // protobuf 打包格式
        MMaterial.setType(MMaterialType)
        MMaterial.setId(id)
        // protobuf 序列化
        let protoBytes = MMaterial.serializeBinary()

        // Uint8Array 转换 Array
        let protoBytesArray = Array.from(protoBytes)
        let material_scene_3_1 = {
          packageId: 0,
          senderId: MATERIAL,
          senderName: MATERIAL_NAME,
          receiverId: SCENE,
          receiverName: SCENE_NAME,
          timeFlag: new Date().getTime(),
          sessionId: 3,
          messageId: 1,
          protoBytesType: 'proto.com.proto.material.MMaterial',
          protoBytes: protoBytesArray
        }
        // console.log('xxxxxx ----> ' + JSON.stringify(protoBytesArray))
        // 发送消息
        Protocol.sender(platform, material_scene_3_1)

      },
      handleThemeChangeDetail(item, type) {
        if(type == 'bgm'){
          this.music_play_status = true
          this.audio_player = ''
          this.bgm_title = item.title
          this.handleSyncBgmDetail(item)
        }
        this.handleChangeMaterial(type, item.oriDataId)
      },
      // 声音修改
      handleVolumeChange(val) {
        let audio = document.getElementById('audio-bgm-material')
        audio.volume = parseFloat(val/100)
        this.handleSendMsgChangeVolume(val)
      },
      // 点击暂停按钮
      handleBgmPause() {
        let audio = document.getElementById('audio-bgm-material')
        this.play_status = false
        audio.pause()
      },
      // 点击取消按钮
      handleBgmCancle() {
        this.handleBgmPause()
        this.bgm_title = ''
        //发送消息取消背景音
        // this.handleChangeMaterial
        this.music_play_status = false
      },
      // 发送消息---音量变化
      handleSendMsgChangeVolume(val){
        let platform = this.$route.query.platform
        let MFloat  = new proto.com.proto.s.MFloat()
        let value = parseFloat(val/100)
        MFloat.setValue(value)
        // protobuf 序列化
        let protoBytes = MFloat.serializeBinary()

        // Uint8Array 转换 Array
        let protoBytesArray = Array.from(protoBytes)
        let bgm_scene_6_17 = {
          packageId: 0,
          senderId: BGMUSIC,
          senderName: BGMUSIC_NAME,
          receiverId: SCENE,
          receiverName: SCENE_NAME,
          timeFlag: new Date().getTime(),
          sessionId: 6,
          messageId: 17,
          protoBytesType: 'proto.com.proto.s.MFloat',
          protoBytes: protoBytesArray
        }
        // 发送消息
        Protocol.sender(platform, bgm_scene_6_17)
      },
      // 同步背景音数据
      handleSyncBgmDetail(item) {
        this.audio_player = item.preview
        let audio = document.getElementById('audio-bgm-material')
        audio.src = item.preview
        audio.volume = 1
        this.volume = 100
        this.handleSendMsgChangeVolume(1)
        // 音乐开始播放
        setTimeout(() => {
          audio.play()
          this.play_status = true
        }, 0)
      },
      //获取主题详情数据
      handleGetThemeDetailData (id) {
        this.theme.material = []
        this.theme.prop = []
        this.theme.bgm = []
        this.theme.scene = []
        let URL = process.env.HOST + '/api/storage/market/themes/' + id + '/matters'
        let params = {}
        let headers = {
          'Authorization': this.has_token
        }
        this.AJAX.get(URL, headers, params).then((data)=>{
          setTimeout(() => {
            this.loading = false
          }, 0)
          this.theme.material = data.result.material
          this.theme.prop = data.result.prop
          this.theme.bgm = data.result.bgm
          this.theme.scene = data.result.scene
        }).catch((err)=>{
          debugger
            this.$message({
              message: err.msg||err.message,
              type: 'error'
            })
        })

      },


      // api--get--素材包--我的
      handleGetPackageDataSelf (type, search_key, current_page, page_size, package_id) {
        let URL = process.env.HOST + '/api/storage/market/packages/'+ package_id + '/resources'
        let headers = {
          'Authorization': this.has_token
        }
        let params = {
          'type': type,
          'page': current_page,
          'pageSize': page_size,
          'keyword': search_key
        }
          console.log('我的购买 =>' + ',' + JSON.stringify(params))
        this.AJAX.get(URL, headers, params).then((data)=>{
          if(data.code == 10000){
            this.pagination_list_count = data.datas.total
          }
          setTimeout(() => {
            this.loading = false
          }, 0)
          // 第一页数据为空
          if(current_page == 1 && data.datas.rows.length == 0){
            this.no_result = true
            this.more = false
          }
          // 正常数据处理
          else{
            this.no_result = false
            this.public_list_data = data.datas.rows
            if(data.datas.rows.length >= this.page_size) {
              this.more = true
              return false
            }else{
              this.more = false
              return false
            }
          }
        }).catch((err)=>{
          debugger
            this.$message({
              message: err.msg||err.message,
              type: 'error'
            })
        })
      },
      // api--get--素材包--团队
      handleGetPackageDataTeam (type, search_key, current_page, page_size, team_id, package_id) {
        let URL = process.env.HOST + '/api/storage/market/packages/'+ package_id + '/resources'
        let headers = {
          'Authorization': this.has_token
        }
        let params = {
          'type': type,
          'page': current_page,
          'pageSize': page_size,
          'keyword': search_key,
          'teamId': team_id
        }
        console.log('团队的购买 =>' + ',' + JSON.stringify(params))
        this.AJAX.get(URL, headers, params).then((data)=>{
          if(data.code == 10000){
            this.pagination_list_count = data.datas.total
          }
          setTimeout(() => {
            this.loading = false
          }, 0)
          // 第一页数据为空
          if(current_page == 1 && data.datas.rows.length == 0){
            this.no_result = true
            this.more = false
          }
          // 正常数据处理
          else{
            this.no_result = false
            this.public_list_data = data.datas.rows
            if(data.datas.rows.length >= this.page_size) {
              this.more = true
              return false
            }else{
              this.more = false
              return false
            }
          }
        }).catch((err)=>{
          debugger
            this.$message({
              message: err.msg||err.message,
              type: 'error'
            })
        })
      },

      // 查看我的是否有素材包
      handleGetSelfPackageStatus (){

        console.log(this.team_id)

        let URL = process.env.HOST + '/api/storage/market/packages/purchased'

        let headers = {
          'Authorization': this.has_token
        }

        let params = {
          'page': '1',
          'pageSize': '100',
          'keyword': ''
        }

        this.AJAX.get(URL, headers, params).then((data)=>{

          if(data.datas.rows.length > 0){

            this.tab_left_pancel = [
              {
                'name': '创建的',
                'active': true,
                'id': 'creat'
              },{
                'name': '购买的',
                'active': false,
                'id': 'buy'
              }
            ]

            this.tab_left_pancel_init = 'creat'
          }else{
            this.tab_left_pancel = [
              {
                'name': '创建的',
                'active': true,
                'id': 'creat'
              }
            ]

            this.tab_left_pancel_init = 'creat'
          }

          // 渲染数据
          this.handleCloseSearch()

        }).catch((err)=>{
            this.$message({
              message: err.msg||err.message,
              type: 'error'
            })

        })
      },

      // 查看团队的是否有素材包
      handleGetTeamPackageStatus (team_id){

        let URL = process.env.HOST + '/api/storage/market/packages/purchased'

        let headers = {
          'Authorization': this.has_token
        }

        let params = {
          'page': '1',
          'pageSize': '100',
          'keyword': '',
          'teamId': team_id
        }

        this.AJAX.get(URL, headers, params).then((data)=>{

          if(data.datas.rows.length > 0){
            this.tab_left_pancel = [
              {
                'name': '创建的',
                'active': true,
                'id': 'creat'
              },{
                'name': '购买的',
                'active': false,
                'id': 'buy'
              }
            ]

            this.tab_left_pancel_init = 'creat'
          }else{
            this.tab_left_pancel = [
              {
                'name': '创建的',
                'active': true,
                'id': 'creat'
              }
            ]

            this.tab_left_pancel_init = 'creat'
          }

          // 渲染数据
          this.handleCloseSearch()

        }).catch((err)=>{
debugger
            this.$message({
              message: err.msg||err.message,
              type: 'error'
            })

        })
      },

      colorSubmit() {
          for(var i=0;i<this.$children.length;i++){
            if(this.$children[i].$el.className == 'vc-photoshop'){
              this.handleColor(this.$children[i].colors.hex)
            }
          }
      },
      // 确认收藏
      handleCollect () {

        this.dialog_collect_visible = false
        this.handlePostCollectMatter(this.ops_id, this.tab_category_init)
      },
      // 确认取消收藏
      handleCancelCollect () {
        this.dialog_cancel_collect_visible = false
        this.handlePostCancelCollectMatter (this.ops_id, this.tab_category_init)
      },
       // api--post--收藏素材
      handlePostCollectMatter (id, type) {
        let URL = process.env.HOST + '/api/storage/market/matters/favorites'
        let dataForm = new FormData()
        dataForm.append('matterId', id)
        dataForm.append('type', type)
        let headers = {
          'Authorization': this.has_token,
        }
        this.AJAX.post(URL, headers, dataForm).then((data)=>{

          this.$message({
            message: '收藏成功',
            type: 'success'
          })
          this.current_page = 1
          this.handleMaterialListData(this.tab_category_init, this.page_size, this.current_page, this.category_id, this.folder_id, this.team_id, this.search_key)
        }).catch((err)=>{
          debugger
            this.$message({
              message: err.msg||err.message,
              type: 'error'
            })
        })
      },

      // api--post--取消收藏
      handlePostCancelCollectMatter (id, type) {
        let URL = process.env.HOST + '/api/storage/market/matters/favorites/delete'
        let params = {
          'matterId': id,
          'type': type
        }
        let headers = {
          'Authorization': this.has_token,
        }
        this.AJAX.post(URL, headers, params).then((data)=>{
          this.$message({
            message: '取消成功',
            type: 'success'
          })
        }).catch((err)=>{
          debugger
            this.$message({
              message: err.msg||err.message,
              type: 'error'
            })
        })
      },

      // 分页组件点击
      handleCurrentChange(page){
          // console.log('handleCurrentChange ==> '+page )
          this.current_page = page == 1?2:page
          this.handleMaterialListData(this.tab_category_init, this.page_size, page, this.category_id, this.folder_id, this.team_id, this.search_key)
      },

      // ------------------------------------------------[ 音乐播放器相关方法 ]-----------------------------------------------
      // 点击播放按钮
      handleBgmPlay() {
        let audio = document.getElementById("audio-bgm-material");

        // 检查音频源是否有效
        if (!audio.src || audio.src === "" || audio.src === window.location.href) {
          console.warn("音频源未设置或无效");
          this.$message.warning("请先选择背景音乐");
          return;
        }

        this.play_status = true;

        // 使用 Promise 处理播放，捕获错误
        audio.play().catch(error => {
          console.error("播放失败:", error);
          this.$message.error("播放失败，请检查音频文件");
          this.play_status = false;
        });
      },

      // 列表点击音乐进行播放
      handleItemPlayBgm(item) {
        let audio = document.getElementById("audio-bgm-material");

        // 检查音频源是否有效
        if (!item.preview || item.preview === "") {
          console.warn("音频源无效:", item);
          this.$message.warning("音频文件地址无效");
          return;
        }

        // 获取音乐相关数据
        this.audio_player = item.preview;
        this.bgm_title = item.title;
        audio.src = item.preview;

        if (this.volume == 0) {
          this.volume = 100;
        }

        audio.volume = parseFloat(this.volume / 100);

        // 等待音频加载后播放
        audio.addEventListener('canplay', () => {
          this.play_status = true;
          audio.play().then(() => {
            this.handleChangeMaterial('bgm', item.id)
          }).catch(error => {
            console.error("播放失败:", error);
            this.$message.error("播放失败，请检查音频文件");
            this.play_status = false;
          });
        }, { once: true });

        // 设置超时，避免长时间等待
        setTimeout(() => {
          if (audio.readyState < 3) {
            console.warn("音频加载超时");
          }
        }, 5000);

        // 显示播放器
        this.music_play_status = true;
      },

    },
    computed: {

      position () {

        if (this.type == 'theme') {
          return 'position'
        }
      },
      position1 () {

        if (this.breadcrumb.length == 1) {
          return 'position1'
        }
      },
      list1 () {
        if(this.tab_category_init == 'material' || this.tab_category_init == 'prop'){

          return 'list1'
        }
        else if(this.tab_category_init == 'theme'){

          return 'list2'
        }
      },
      // 搜索隐藏左侧daohang
      hideLeft () {
        if(this.search_status || this.tab_left_pancel.length == 1){
          return 'position-left0'
        }
      },
      publicList () {
        if(this.tab_category_init == 'material' || this.tab_category_init == 'prop'){

          return 'list1'
        }
      },
      teamSelfList () {
        if(this.tab_category_init == 'material' || this.tab_category_init == 'prop'){

          return 'list1'
        }
      }
    },
    watch: {
      'search_key':function(){
        // this.search_key = this.search_key.replace(/(^\s*)|(\s*$)/g, "")
        if(this.search_key == ''){
          if(this.search_status){
            this.handleCloseSearch()
          }
        }
      }
    },
    created(){
      eventBus.$on('handleCollect_material',target=>{
        this.handleCollect();
      });
      eventBus.$on('handleCancelCollect_material',target=>{
        this.handleCancelCollect();
      });
    },
    // 渲染
    mounted () {

      let _this = this
      let  platform = _this.$route.query.platform
      _this.platform_type = platform
      _this.loading = true
      // MATERIAL
      // 模块初始化
      Protocol.onSocketInit(platform, MATERIAL_NAME, MATERIAL)
      // 模块与服务器建立链接
      Protocol.onSocketConnect(platform, MATERIAL_NAME)
      // 模块与服务器建立链接
      Protocol.onSocketRegister(platform, MATERIAL_NAME, MATERIAL)

      window[MATERIAL_NAME].domReady = () => {

        // 向用户系统请求用户数据
        let material_core_1_3 = {
          packageId: 0,
          senderId: MATERIAL,
          senderName: MATERIAL_NAME,
          receiverId: CORE,
          receiverName: CORE_NAME,
          timeFlag: new Date().getTime(),
          sessionId: 1,
          messageId: 3,
          protoBytesType: '',
            protoBytes: []
        }
        // 发送消息
        Protocol.sender(platform, material_core_1_3)
        //请求Token
        let material_core_1_1 = {
          packageId: 0,
          senderId: MATERIAL,
          senderName: MATERIAL_NAME,
          receiverId: CORE,
          receiverName: CORE_NAME,
          timeFlag: new Date().getTime(),
          sessionId: 1,
          messageId: 1,
          protoBytesType: 'proto.com.proto.s.MToken',
          protoBytes: []
        }
        // 发送消息
        Protocol.sender(platform, material_core_1_1)
        // 请求当前tab数据
        let material_core_1_11 = {
          packageId: 0,
          senderId: MATERIAL,
          senderName: MATERIAL_NAME,
          receiverId: CORE,
          receiverName: CORE_NAME,
          timeFlag: new Date().getTime(),
          sessionId: 1,
          messageId: 11,
          protoBytesType: '',
          protoBytes: []
        }
        // 发送消息
        Protocol.sender(platform, material_core_1_11)

        // 检查场景是否加载完成
        let material_scene_6_26 = {
          packageId: 0,
          senderId: MATERIAL,
          senderName: MATERIAL_NAME,
          receiverId: SCENE,
          receiverName: SCENE_NAME,
          timeFlag: new Date().getTime(),
          sessionId: 6,
          messageId: 26,
          protoBytesType: '',
          protoBytes: []
        }
        // 发送消息
        Protocol.sender(platform, material_scene_6_26)
      }
      // 接收消息
      Protocol.receiver(platform, MATERIAL_NAME)

      window[MATERIAL_NAME].message = (senderId, packageId, sessionId, messageId, protoBytes) => {
        // 场景加载完成
        if(sessionId == 6 && messageId == 5) {

        }
        // 同步团队型信息
        if (sessionId == 1 && messageId == 12) {
          let arr = Protocol.deserializeBinary('proto.com.proto.s.MTabData', protoBytes).array

          _this.tab_type = arr[0]

          let material_core_1_1 = {
            packageId: 0,
            senderId: MATERIAL,
            senderName: MATERIAL_NAME,
            receiverId: CORE,
            receiverName: CORE_NAME,
            timeFlag: new Date().getTime(),
            sessionId: 1,
            messageId: 1,
            protoBytesType: 'proto.com.proto.s.MToken',
            protoBytes: []
          }
          // 发送消息
          Protocol.sender(platform, material_core_1_1)
          if (_this.has_token) {
             if(arr[4]){
                _this.tab_tab = [
                  {
                    "name": arr[5],
                    "active": true,
                    "type": 'team'
                  },
                  {
                    "name": '公共市场',
                    "active": false,
                    "type": 'public'
                  },
                  {
                    "name": '我的',
                    "active": false,
                    "type": 'self'
                  }
                ]
                _this.team_id = arr[4]

                _this.team_name = arr[5]
                _this.tab_tab_init = 'team'
              }else{
                _this.tab_tab = [
                  {
                    "name": '公共市场',
                    "active": false,
                    "type": 'public'
                  },
                  {
                    "name": '我的',
                    "active": true,
                    "type": 'self'
                  }
                ]

                 _this.team_id = ''
                 _this.team_name = ''
                 _this.tab_tab_init = 'public'
              }
            let initIndex = 0;
            // 清空breadcrumb
            _this.breadcrumb = []
            if (_this.tab_type == 1) {
              //如果是团队的
                if('' != _this.team_id) {
                    _this.tab_category = [
                        { name: '模板', active: false, type: 'template' },
                        { name: '场景', active: true, type: 'scene' },
                        { name: '形象', active: false, type: 'material' },
                        { name: '道具', active: false , type: 'prop'},
                        { name: '组件', active: false , type: 'component'},
                        { name: '音乐', active: false , type: 'bgm'},
                    ]
                    initIndex = 1;
                }else {
                    _this.tab_category = [
                        { name: '模板', active: false, type: 'template' },
                        { name: '主题', active: false, type: 'theme'},
                        { name: '场景', active: true, type: 'scene' },
                        { name: '形象', active: false, type: 'material' },
                        { name: '道具', active: false , type: 'prop'},
                        { name: '音乐', active: false , type: 'bgm'},
                    ]
                    initIndex = 2;
                }
                _this.handleCategoryChange(initIndex);
                _this.handleGetCategoryList(_this.tab_category_init)
                _this.handleMaterialListData(_this.tab_category_init, _this.page_size, _this.current_page, _this.category_id, _this.folder_id, _this.team_id, _this.search_key)
            }else if (_this.tab_type == 2) {
                _this.tab_category = [
                    { name: '形象', active: true, type: 'material' },
                    { name: '道具', active: false , type: 'prop'},
                ]
                initIndex = 0;
                _this.tab_category_init = 'material'
                _this.handleCategoryChange(initIndex);
                _this.handleGetCategoryList(_this.tab_category_init)
                _this.handleMaterialListData(_this.tab_category_init, _this.page_size, _this.current_page, _this.category_id, _this.folder_id, _this.team_id, _this.search_key)
            }else if (_this.tab_type == 3) {
                _this.tab_category = [
                    { name: '形象', active: false, type: 'material' },
                    { name: '道具', active: true , type: 'prop'}
                ]
                initIndex = 1;
                _this.tab_category_init = 'material'
                _this.handleCategoryChange(initIndex);
                _this.handleGetCategoryList(_this.tab_category_init)
                _this.handleMaterialListData(_this.tab_category_init, _this.page_size, _this.current_page, _this.category_id, _this.folder_id, _this.team_id, _this.search_key)
            }
        }
    }

        // 同步用户信息--id
        if (sessionId == 1 && messageId == 4){
          let arr = Protocol.deserializeBinary('proto.com.proto.s.UserInfo', protoBytes).array

          _this.has_user_id = arr[3][0]

          _this.self_name = arr[3][4]

        }
        // 同步token
        else if(sessionId == 1 && messageId == 2) {

          let is_token = Protocol.deserializeBinary('proto.com.proto.s.MToken', protoBytes).array
         this.$parent.$parent.has_token = _this.has_token = is_token[0]


        }else if(sessionId == 1 && messageId == 12){ // changeTab
            _this.loading = true
            _this.public_list_data = []

            // _this.tab_tab = [
            //       {
            //         "name": '公共市场',
            //         "active": true,
            //         "type": 'public'
            //       },{
            //         "name": '我的',
            //         "active": false,
            //         "type": 'self'
            //       }
            //     ]
            // console.log('has 6666 ===> c')
            // _this.team_id = ''
            // _this.team_name = ''
            // _this.tab_tab_init = 'public'
        }
        // 锁定模块
        else if (sessionId == 1 && messageId == 13){
          _this.mask_visible = true
        }
        // 解除锁定
        else if (sessionId == 1 && messageId == 14){
          _this.mask_visible = false
        }

        else if (sessionId == 7 && messageId == 16){
          let arr = Protocol.deserializeBinary('proto.com.proto.s.MString', protoBytes).array
          //  console.log("arr ===>" + arr + 'ffff')
          if (arr.length == 0) {
            _this.tab_category_action = _this.tab_category = [
              { name: '形象', active: true, type: 'material' },
              { name: '道具', active: false , type: 'prop'},
            ]
            _this.tab_category_init = 'material'
            _this.handleMaterialListData(_this.tab_category_init, _this.page_size, _this.current_page, _this.category_id, _this.folder_id, _this.team_id, _this.search_key)
            return
         }
          // if (arr[0].substring(0, 2) == 20) {
            let substring = arr[0].substring(2, 21)
            if (substring == '0000000000000001001' || substring == '0000000000000002001' || substring == '0000000000000003001'
                || substring == '0000000000009000001') {
            _this.tab_category_action = _this.tab_category = [
              { name: '形象', active: true, type: 'material' }
            ]
            _this. select_prop = "";
            _this.tab_category_init = 'material'
            _this.handleMaterialListData(_this.tab_category_init, _this.page_size, _this.current_page, _this.category_id, _this.folder_id, _this.team_id, _this.search_key)
          }else if (substring == '0000000000000004001' || substring == '0000000000000005001') {
                // if (arr[0].substring(0, 2) == 23) {
            _this.tab_category_action = _this.tab_category = [
              { name: '道具', active: true , type: 'prop'}
            ]
            _this. select_prop = _this.tab_category ;
            _this.tab_category_init = 'prop'
            _this.handleMaterialListData(_this.tab_category_init, _this.page_size, _this.current_page, _this.category_id, _this.folder_id, _this.team_id, _this.search_key)
          }
        }
        if (sessionId == 7 && messageId == 17){
            _this.tab_category_action = _this.tab_category = [
              { name: '道具', active: true , type: 'prop'}
            ]
            _this. select_prop = _this.tab_category ;
            _this.tab_category_init = 'prop'
            _this.handleMaterialListData(_this.tab_category_init, _this.page_size, _this.current_page, _this.category_id, _this.folder_id, _this.team_id, _this.search_key)
        }
      }
    }
  }
</script>
<style>
.el-collapse-item__header{
  background:#e8e8e8;
}
.el-collapse-item__wrap{
  background:#e8e8e8;
}
.list .vc-photoshop{
  background:none;
  box-shadow: none;
}
.vc-ps-head{
  display:none;
}
.vc-photoshop .vc-ps-body{
  padding:0;
  display: block;
}
.vc-ps-body .vc-ps-controls{
  margin: 0;
}
.vc-photoshop .vc-ps-body .vc-ps-saturation-wrap {
  width: 150px;
  height: 150px;
  float: left;
}
.vc-photoshop .vc-ps-body .vc-ps-hue-wrap{
  width: 20px;
  height: 150px;
  float: left;
}
.vc-ps-controls .vc-ps-ac-btn{
  margin-top:10px;
  border-radius:4px;
  height: 34px;
  line-height: 34px;
  margin: 0;
  margin-top: 2px;
}
.vc-ps-previews__pr-color:nth-child(2){
  display:none;
}
.vc-ps-previews__label{
  display:none;
}
.vc-ps-ac-btn{
  display:none;
}
.vc-ps-fields .vc-ps-fields__divider{
  height: 20px;
}
::-webkit-input-placeholder { /* placeloder 字体颜色 */
    color:#d2d2d2;
    font-size:14px;
    font-family:PingFangSC-Light;
  }
</style>
<style lang="stylus" scoped>
  .material
    background: #505050//#e8e8e8
    position: absolute
    top: 0px
    right: 0
    bottom: 0
    left: 0
    .loading
      position: absolute
      left: 0
      top: 0
      width: 280px
      height: 100%
      background:#3a3a3a
    .mask
      position: absolute
      top: 25px
      right: 0
      bottom: 0
      left: 0
      background: #3a3a3a//rgba(255, 255, 255,.8)
      z-index: 1
    .title
      background: #a6a6a6
      line-height: 25px
      text-align: center
      color: #3f3f3f
    .tabs
      display: flex
      div
        background: #3d3d3d//#f0f0f0
        color: #fff//#5a5a5a//#333
        flex: 1
        line-height: 25px
        border: 1px solid #3d3d3d
        text-align: center
        cursor: pointer
        box-sizing: border-box
      .active
        color: #fff//#2f2f2f
        background: #505050//#e8e8e8
        border-right:1px solid #3d3d3d
    .search
      padding: 10px 10px 0 10px
      position: relative
      .search-inner
        .text
          border: 1px solid #e7e7e7
          background: #fff
          height: 25px
          width: 100%
          padding: 0 5px
          box-sizing: border-box
        :disabled
          border: 1px solid #e7e7e7
          background: #eee
          color: red !important
        .button
          position: absolute
          top: 10px
          cursor pointer
        .icon-search
          right: 10px
          color: #666
          font-size: 24px
        .el-icon-close
          top: 17px
          right: 32px
          &:hover
            color: #717171
          &:active
            color: #4A4A4A

    .category-nav
      padding: 7px 0px 0px 10px
      height: 16px
      background:#3d3d3d
      position:relative
      top:10px
      div
        float: left
        height: 16px
        line-height: 16px
        font-size: 12px
        text-align:center
        cursor: pointer
        width:100%
        margin-top:-2px
        color:#e2e2e2
        display:inline
      .active
        color: #7ab3f6
        font-weight: bold
      .bottom
        float: left
        display:inline-block
        margin-left:10px
        height: 18px
        line-height: 18px
        cursor: pointer
        width: 35px
      .active
        background: url(./material_bottom.png) no-repeat
    .player {
      width: 100%;
      height: 30px;
      position: absolute;
      top: 100px;
      left: 0;
      right: 0;
      z-index: 100;

      .box-music {
        background: #c9c9c9;
        margin: 0 10px;
        box-sizing: border-box;
        border-radius: 5px;

        .title {
          padding: 0 10px;
          box-sizing: border-box;
          padding-top: 10px;
          position: relative;
          padding-right: 25px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          .el-icon-close {
            position: absolute;
            cursor: pointer;
            right: 10px;
            color: #aeaeae;
            font-size: 13px;

            &:hover {
              color: #717171;
            }

            &:active {
              color: #4a4a4a;
            }
          }
        }

        .control {
          padding: 0 45px;
          padding-left: 60px;
          box-sizing: border-box;
          position: relative;

          .play_pause {
            position: absolute;
            left: 10px;
            top: 7px;
            overflow: hidden;

            i {
              color: #aeaeae;
              font-size: 20px;
              float: left;
              height: 20px;
              line-height: 20px;

              &:hover {
                color: #717171;
              }

              &:active {
                color: #4a4a4a;
              }
            }

            .icon-volume-mute2 {
              margin-left: 5px;
            }

            .icon-volume-medium {
              margin-left: 5px;
            }

            .icon-play2 {
              cursor: pointer;
            }

            .icon-pause {
              cursor: pointer;
            }
          }

          .volume_show {
            position: absolute;
            right: 10px;
            top: 10px;
            font-size: 14px;
          }
        }
      }
      audio {
        width: 100%;
        height: 30px;
        display: none;
      }
    }
    .public
      position: absolute
      top: 110px
      right: 0
      bottom: 0
      left: 0
      .category-type
        position: absolute
        background: #3d3d3d//#dbdbdb
        color: #e2e2e2//#3d3d3d
        width: 54px
        top: 0
        left: 0
        bottom: 0
        overflow auto
        div
          line-height: 30px
          text-align: center
          cursor: pointer
          span
            display: block
            font-size: 12px
            -webkit-transform: scale(0.8)
        .active
          background: #505050//#e8e8e8
      .breadcrumb
          line-height: 30px
          position: absolute
          top: -21px
          box-sizing: border-box
          padding: 0 5px 5px 5px
          overflow: auto
          span
            line-height: 30px
            display: inline-block
            padding-right: 5px
            color: #20a0ff
            cursor: pointer
      .list-wrapper
        position: absolute
        top: 10px
        right: 0
        bottom: 0
        left: 54px
        box-sizing: border-box
        padding: 0 5px 5px 5px
        overflow: auto
        // background:green
        &.position
          left: 0
        .list
          .item
            float: left
            width: 105px
            cursor: pointer
            position: relative
            .inner
              padding: 0 5px 10px 5px
              // background:red
              .padding
                padding: 0
              .pic
                background: #fff
                min-height: 10px
                img
                  width: 100%
                  display: block
                  height:54px
                  max-height:90px
              .text
                background: #fff
                .name,
                .desc
                  padding: 3px 0
                  color: #ccc
                  font-size: 12px
                  -webkit-transform: scale(0.8)
                  margin-left: -5px
                  text-align: center
                  overflow: hidden
                  white-space: nowrap
                  text-overflow: ellipsis
                .name
                  height: 10px
                  color: #666
                .tip
                  position: absolute
                  right: 5px
                  top: 0
                  color: #619ee6
                  text-indent: -9999px
                  width: 29px
                  height: 29px
                  background: url(tip_free.png)
          .item-bgm {
            float: left;
            cursor: pointer;
            position: relative;
            padding: 10px 0;
            border-bottom: 1px solid #c7c7c7;
            width: 100%;

            .inner {
              overflow: hidden;
              padding-left: 45px;

              .padding {
                padding: 10px;
              }

              .pic {
                min-height: 40px;
                width: 40px;
                height: 40px;
                border-radius: 5px;
                float: left;
                position: absolute;
                top: 10px;
                left: 5px;

                img {
                  width: 40px;
                  height: 40px;
                  border-radius: 5px;
                  display: block;
                }
              }

              .text {
                float: left;
                margin-left: 10px;
                width: 100%;

                .name, .desc {
                  color: #999;
                  font-size: 12px;
                  height: 15px;
                  line-height: 15px;
                  box-sizing: border-box;
                  margin-top: 5px;
                  width: 100%;
                }

                .name {
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  color: #e2e2e2//#666;

                  .tips {
                    float: right;
                    margin-right: 20px;
                    color: #5e9be3;
                  }
                }
              }
            }
          }
          .list1
            // background:red
            float: left
            width: 70px
            cursor: pointer
            position: relative
            .inner
              // background:blue
              position:relative
              padding: 0 6px 10px 0
              .padding
                padding: 2px 10px 2px 0px
              .pic
                background: #505050//#e8e8e8
                padding:0
                height:70px
                width:100%
                line-height:70px
                text-align:center
                img
                  top:0
                  width:auto
                  height:70px
                  max-width:100%
                  max-height:100%
                  display: inline-block
                  vertical-align:middle
              .text
                  background: #505050
                  .name,
                  .desc
                    color:#d1d1d1
                  .tip
                    background: rgba(255, 255, 255,0.01)
        .color
          overflow hidden
          margin-top 10px
          li
            float left
            width 43px
            height 43px
            margin 2px
            cursor pointer
          .vc-photoshop
            width 200px
            .vc-ps-head
              display none
      .position-left0
        left 0
    .private-team
      position: absolute
      top: 100px
      right: 0
      bottom: 0
      left: 0
      overflow auto
      .breadcrumb
        margin-bottom: 10px
        padding-left: 10px
        padding-top: 5px
        clear
        span
          display: inline-block
          padding-right: 5px
          color: #20a0ff
          cursor: pointer
      .list
        box-sizing: border-box
        padding: 0 5px 5px 5px
        overflow auto
        .con
          overflow: hidden
          .item
            float: left
            width: 117px
            cursor: pointer
            position: relative
            .inner
              padding: 0 5px 10px 5px
              background:red
              .pic
                // background: #fff
                min-height: 10px
                height 50px
                img
                  width: 100%
                  display: block
                  height 50px
          .list1
            .inner
              padding: 0 5px 10px 5px
              .padding
                padding: 10px
                box-sizing border-box
              .pic
                background: #3d3d3d//#fff
                min-height: 10px
                height 90px
                img
                  width: 100%
                  display: block
                  height 90px
                  padding:0 6px 0 0
              .text
                background: #3d3d3d
                .name,
                .desc
                  color:#d1d1d1
              .folder
                background: #fff
                padding-top 20px
                box-sizing border-box
                img
                  width: 50px
                  height: 50px
                  margin: 0 auto
                  display: block
      .position1
        top: 0
    .more
      padding: 0 5px 5px 5px
      .inner
        padding: 10px
        text-align: center
        background: #fff
    .loadMore
        position:absolute
        margin-left:40px
        height:30px
        background:#E8E8E8
        bottom:0px
        width:100%
        text-align:center
        background:#3d3d3d
        .pagination
          position:absolute
          // background:green
          width:100%
          margin-top:0px
          margin-left:-25px
          -webkit-transform: scale(0.8)
          height:30px

    .no_results
      width 200px
      position absolute
      left 80px
      margin-top:100px
      .pic
        width 200px
        margin 0 auto
        img
          width 100%
      .text
        text-align center
        margin-top 20px
    .theme-detail
      position: absolute
      top: 85px
      right: 0
      bottom: 0
      left: 0
      overflow auto
      padding: 0 5px 5px 5px
      .theme-item
        overflow auto
        margin-top 10px
        .title1
          margin-bottom 20px
        .item
          float: left
          width: 105px
          cursor: pointer
          position: relative
          .inner
            padding: 0 5px 10px 5px
            .padding
              padding: 0
            .pic
              background: #fff
              min-height: 10px
              img
                width: 100%
                display: block
                height: 54px
                max-height: 90px
            .text
              background: #fff
              .name,
              .desc
                padding: 3px 0
                color: #ccc
                font-size: 12px
                -webkit-transform: scale(0.8)
                margin-left: -5px
                text-align: center
                overflow: hidden
                white-space: nowrap
                text-overflow: ellipsis
              .name
                height: 10px
                color: #666
              .tip
                position: absolute
                right: 5px
                top: 0
                color: #619ee6
                text-indent: -9999px
                width: 29px
                height: 29px
                background: url(tip_free.png)
        .list1
            .inner
              padding: 0 5px 10px 5px
              .padding
                padding: 10px
              .pic
                background: #3d3d3d//#fff
                min-height: 10px
                height 90px
                img
                  width: 100%
                  display: block
                  height 90px
              .text
                background: #3d3d3d
                .name,
                .desc
                  color:#d1d1d1
          .list2
            .inner
              .pic
                height 55px
                img
                  height 55px
        .item_bgm
          float: left
          padding 10px 0
          border-bottom 1px solid #c7c7c7
          width 100%
          cursor: pointer
          position: relative
          .inner_bgm
            overflow hidden
            padding-left 45px
            .pic_bgm
              min-height: 40px
              width 40px
              height 40px
              border-radius 5px
              float left
              position absolute
              top 10px
              left 5px
              img
                width 40px
                height 40px
                border-radius 5px
                display: block
            .text_bgm
              float left
              margin-left 10px
              width 100%
              .name_bgm,
              .desc_bgm
                color: #999
                font-size 12px
                height 15px
                line-height 15px
                box-sizing border-box
                margin-top 5px
                width 100%
              .name_bgm
                overflow: hidden
                white-space: nowrap
                text-overflow: ellipsis
                color: #666
                .tips
                  float right
                  margin-right 20px
                  color #5e9be3

  // 播放器显示时，内容区向下移动
  .position_top
    top: 160px !important
</style>



// WEBPACK FOOTER //
// Material.vue?5a8f2bd8